var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn-follow', { 'followed': _vm.isFollow }],on:{"click":_vm.onClick}},[_vm._v(_vm._s(_vm.$t(_vm.isFollow ? 'btn-follow.followed' : 'btn-follow.not-follow')))])}
var staticRenderFns = []

export { render, staticRenderFns }